export default __webpack_public_path__ + "static/media/gray-bg.32876552.png";